
import * as THREE from "three"


// >> make grids ( segments ) from geometry
Object.assign(THREE.PlaneBufferGeometry.prototype, {
    toGrid: function() {
        let segmentsX = this.parameters.widthSegments || 1;
        let segmentsY = this.parameters.heightSegments || 1;
        let indices = [];
        for (let i = 0; i < segmentsY + 1; i++) {
            let index11 = 0;
            let index12 = 0;
            for (let j = 0; j < segmentsX; j++) {
                index11 = (segmentsX + 1) * i + j;
                index12 = index11 + 1;
                let index21 = index11;
                let index22 = index11 + (segmentsX + 1);
                indices.push(index11, index12);
                if (index22 < ((segmentsX + 1) * (segmentsY + 1) - 1)) {
                    indices.push(index21, index22);
                }
            }
            if ((index12 + segmentsX + 1) <= ((segmentsX + 1) * (segmentsY + 1) - 1)) {
                indices.push(index12, index12 + segmentsX + 1);
            }
        }
        this.setIndex(indices);
        return this;
    }
})

import app_parameters from './../app/parameters'


/**
 * Grid
 *
 * this.geometry.attributes.position.array
 *
 */
export default class Grid {

    /**
     *
     * parameters = {
     *      width:
     *      height:
     *      uv: {
     *          u:
     *          v:
     *      }
     *      texture:
     *      repeat:
     *      dot: {
     *          size:
     *          color:
     *      }
     * }
     *
     * @param parameters
     * @returns {Grid}
     */
    constructor( parameters ) {



        /**
         * geometry
         * @type THREE.PlaneGeometry
         */
        this.geometry = null

        /**
         * geometrylines
         * @type THREE.PlaneBufferGeometry
         */
        this.geometrylines = null

        /**
         * display
         * @type {boolean}
         */
        this.display = true



        if (typeof(parameters.texture) !== "undefined" && parameters.texture != null) {

            parameters.texture.wrapS = THREE.RepeatWrapping
            parameters.texture.wrapT = THREE.RepeatWrapping
            parameters.texture.repeat.set(
                parameters.repeat,
                parameters.repeat
            )

        } else {

            parameters.texture = null

        }

        this.parameters = parameters

        if ( typeof(parameters.dot) === 'undefined' ) {
            parameters.dot = {

            }
        }


            if ( typeof(parameters.dot.color) === 'undefined' ) {

            // not set, put default value

            this.parameters.dot.color = ( typeof(app_parameters.scene.model.dot.color) !== 'undefined' )
                ? app_parameters.scene.model.dot.color : 0x0000ff

        }

        if ( typeof(parameters.dot.size) === 'undefined' ) {

            this.parameters.dot.size = (typeof(app_parameters.scene.model.dot.size) !== 'undefined')
                ? app_parameters.scene.model.dot.size : 10

        }

        this.uuid = this.uuid()

        /*this.uv = {
            u: parameters.uv.u,
            v: parameters.uv.v
        }*/

        this.setGeometry    ()
            .setMesh        ()
            .setDots        ()
            .setGrid        ()  // grid segments from dots

        if ( typeof(parameters.import) !== 'undefined' && parameters.import !== false && parameters.import !== null ) {

            // import - crush..

            this.import(parameters.import)

        }

        return this

    }

    getGridLine() {

        return this.gridline

    }

    getDots() {

        return this.dots

    }

    isDisplay() {

        return this.display

    }

    setGeometry() {

        this.geometry = new THREE.PlaneGeometry(
            this.parameters.width,
            this.parameters.height,
            this.parameters.uv.u,
            this.parameters.uv.v
        )

        // index
        this.geometrylines = new THREE.PlaneBufferGeometry(
            this.parameters.width,
            this.parameters.height,
            this.parameters.uv.u,
            this.parameters.uv.v
        ).toGrid()

        this.geometry.verticesNeedUpdate = true
        this.geometrylines.verticesNeedUpdate = true

        return this

    }

    blending() {

        this.material.blending = THREE.CustomBlending

    }

    opacity(opacity) {

        this.material.blending = THREE.NormalBlending
        this.material.opacity = opacity

    }

    dotsHide() {

        this.dots.visible = false

        return this

    }

    gridlineHide() {

        this.gridline.visible = false

        return this

    }

    dotsShow() {

        this.dots.visible = true

        return this

    }

    gridlineShow() {

        this.gridline.visible = true

        return this

    }


    modifyTexture( texture ) {

        this.material.map = texture

    }


    setTexture( texture ) {

        this.material.map = texture

    }


    getTexture( ) {

        return this.material.map

    }


    setMesh(  ) {

        //this.parameters.texture.anisotropy = 16

        this.material = new THREE.MeshBasicMaterial({

            map: this.parameters.texture,

            //alphaMap: ,
            name: this.uuid,

            side: THREE.DoubleSide,

            opacity: 1,   // @option

            transparent: true,
            needsUpdate: true,

            //wireframe: true,

            depthTest: false,

            // https://threejs.org/examples/#webgl_materials_blending_custom

            blending: THREE.CustomBlending,   // @option // NormalBlending
            blendEquation: THREE.AddEquation,
            blendSrc: THREE.ZeroFactor, // ZeroFactor
            blendDst: THREE.SrcColorFactor  // SrcColorFactor


        })

        this.material.needsUpdate = true

        // wireframe
        //this.material = new THREE.MeshBasicMaterial({ wireframe: true })

        this.mesh = new THREE.Mesh(
            this.geometry,
            this.material
        )

        //this.dots.position.z = this.geometry.mesh.z

        return this

    }


    /**
     * Control Points
     * @returns {Grid}
     */
    setDots() {

        this.dots = new THREE.Points(
            this.geometry,
            new THREE.PointsMaterial({

                size: this.parameters.dot.size,
                color: this.parameters.dot.color,
                sizeAttenuation: true,


                //blending: THREE.CustomBlending,   // @option
                blendEquation: THREE.AddEquation,
                blendSrc: THREE.SrcAlphaFactor,
                blendDst: THREE.OneMinusSrcColorFactor,
                blendSrcAlpha: 0.8

            })
        )

        this.dots.name = 'PointsControl'

        return this

    }

    setDisplay( boolean ) {

        this.display = boolean

    }

    /**
     * Grid
     * @returns {Grid}
     */
    setGrid() {

        let color

        if ( typeof(this.parameters.dot.color) === 'undefined' ) {

            color = (typeof(app_parameters.scene.model.grid.color) !== 'undefined')
                ? app_parameters.scene.model.grid.color : 0x00ff00

        } else {

            color = this.parameters.dot.color

        }

        this.gridline = new THREE.LineSegments(
            this.geometrylines,
            new THREE.LineBasicMaterial({
                color: color,
                transparent: true,
                opacity: 0.6,
                //linewidth:  1 // TubeGeometry
            })
        )

        return this

    }

    getUCount() {

        return this.parameters.uv.u

    }

    getVCount() {

        return this.parameters.uv.v

    }

    getUVCount() {

        return this.parameters.uv.u * this.parameters.uv.v

    }

    lineUAdd( index ) {

        return

        /*this.geometry.vertices.splice(10,0,new THREE.Vector3(333,333,0))

        this.geometry.verticesNeedUpdate = true

        return this.geometry

        let indexStart, indexStop

        indexStart = this.getUVCount()
        indexStop = this.getUCount()

        console.log(indexStart,indexStop)


        //for( let i = 0 ; i < e.vertices.length ; i++ ) {
        for( let i = indexStart ; i < indexStart + indexStop ; i++ ) {

            //let v = this.getDot( i - this.getUCount() )

            //console.log(i,v, i - this.getUCount())

//            this.dotPush( i , v.x, v.y, v.z , true )
            this.dotPush( i , 10*i , index , 0 , true )

        }

        this.parameters.uv.u = this.parameters.uv.u + 1

        /*if (index > this.geometry.vertices.length-1)
            return false

        // dot

        this.geometry.vertices[index].set(x,y,z)

        this.geometry.verticesNeedUpdate = true

        // grid

        this.geometrylines.attributes.position.setXYZ(index,x,y,z)

        this.geometrylines.attributes.position.needsUpdate = true
        */

    }

    import(e) {

        //console.log('grid:import')

        // verify format

        this.uuid = e.name

        this.parameters.uv.u = e.uv.u
        this.parameters.uv.v = e.uv.v

        this.parameters.width = e.size.width
        this.parameters.height = e.size.height

        // update geometry

        this.setGeometry    ()

        for( let i = 0 ; i < e.vertices.length ; i++ ) {

            let v = e.vertices[i]

            this.dot( i, v.x, v.y, v.z )

        }

        //this.geometry.verticesNeedUpdate = true

        this.setMesh        ()
        this.setDots        ()
        this.setGrid        ()

        return this

    }

    export() {

        let e = {

            type: 'grid',

            name: this.uuid,

            size: {
                  width:    this.parameters.width,
                  height:   this.parameters.height
            },

            uv: {
                u: this.parameters.uv.u,
                v: this.parameters.uv.v
            },

            vertices: []

        }

        let vertices_array = this.geometry.attributes.position.array

        //this.geometry.vertices // deprecated

        for( let i = 0 ; i < vertices_array.length ; i=i+3 ) {

            e.vertices.push({
                x: vertices_array[i],
                y: vertices_array[i+1],
                z: vertices_array[i+2]
            })

        }

        return e

    }


    /**
     * getVertices
     *
     * for history purposes
     *
     * @return array
     */
    getVertices() {

        //Float32Array to array

        var array = []
        for (var i=0; i< this.geometrylines.attributes.position.array.length; i++)
            array[i] = this.geometrylines.attributes.position.array[i]

        return array

    }

    /**
     * setVertices
     *
     * for history purposes
     *
     * @param verticesArray
     */
    setVertices( verticesArray ) {

        // https://threejsfundamentals.org/threejs/lessons/threejs-custom-buffergeometry.html
        // new Float32Array

        let real_index = 0

        for( let i=0 ; i < verticesArray.length ; i=i+3 ) {

            this.dot(
                real_index,
                verticesArray[i],
                verticesArray[i+1],
                verticesArray[i+2]
            )

            real_index++

        }


    }


    /**
     *
     * modify dot position (dragging)
     * @param index
     * @param x
     * @param y
     * @param z
     * @returns {Grid}
     */
    dot(index,x,y,z) {

        // @todo deprecation of THREE.Geometry in r125 so I don't think there is an easier way (PlaneGeometry inherits from BufferGeometry now)

        if (index > this.geometry.attributes.position.count-1)
            return false

        //console.log( index,x,y,z )

        // dot

        this.geometry.attributes.position.setXYZ(index,x,y,z)

        this.geometry.attributes.position.needsUpdate = true

        // grid

        this.geometrylines.attributes.position.setXYZ(index,x,y,z)

        this.geometrylines.attributes.position.needsUpdate = true

        return this

    }

    getMesh() {

        return this.mesh

    }


    getDot(index) {

        let dot = {
            x: this.geometry.attributes.position.array[index],
            y: this.geometry.attributes.position.array[index],
            z: this.geometry.attributes.position.array[index]
        }
        //console.log(dot) //@todo check
        return dot

        //return this.geometry.vertices[index]    // @todo deprecated
        //return this.geometry.attributes.position.array[index]

    }


    getUV(index) {

        let u = Math.floor( index / ( this.parameters.uv.u + 1) ),

        v = index - (( this.parameters.uv.v + 1) * u ) //- 1 //Math.floor( index / ( this.parameters.uv.v + 1) )

        return [u,v]

    }


    /**
     * lineU : move u line
     *
     * @param index
     * @param x
     * @param y
     * @param z
     * @param vertices
     * @returns {*}
     */
    lineU( index , x , y , z , vertices ) {

        // u

        if ( index > this.parameters.uv.u )
            return false

        let xx = 0, yy = 0, zz = 0, dot = null

        for( let i = 0 ; i <= this.parameters.uv.u ; i++ ) {

            let ii = i + index * this.parameters.uv.u + index

            dot = this.getDot(ii)

            if (typeof(vertices) !== 'undefined') {

                // use vertices as saved position for dragging

                xx = vertices[i].x + x
                yy = vertices[i].y + y
                zz = vertices[i].z + z

            } else {

                xx = dot.x + x
                yy = dot.y + y
                zz = dot.z + z

            }

            this.dot( ii , xx, yy, zz )

            //console.log( ii )

        }

        return this

    }


    getLineU(index) {

        // u

        if ( index > this.parameters.uv.u )
            return false

        let xx = 0, yy = 0, zz = 0, dot = null, vertices = []

        for( let i = 0 ; i <= this.parameters.uv.u ; i++ ) {

            let ii = i + index * this.parameters.uv.u + index

            dot = this.getDot(ii)

            //vertices.push(dot) // ref issue

            vertices.push({
                x: dot.x,
                y: dot.y,
                z: dot.z,
            })

            /*xx = dot.x + x
            yy = dot.y + y
            zz = dot.z + z

            this.dot( ii , xx, yy, zz )*/

            //console.log( ii )

        }

        return vertices

    }


    getLineV(index) {

        // u

        if ( index > this.parameters.uv.u )
            return false

        let xx = 0, yy = 0, zz = 0, dot = null, vertices = []

        for( let i = 0 ; i <= this.parameters.uv.v ; i++ ) {

            let ii = i * this.parameters.uv.u + index + i

            dot = this.getDot(ii)

            //vertices.push(dot) // ref issue

            vertices.push({
                x: dot.x,
                y: dot.y,
                z: dot.z,
            })

            /*xx = dot.x + x
            yy = dot.y + y
            zz = dot.z + z

            this.dot( ii , xx, yy, zz )*/

            //console.log( ii )

        }

        return vertices

    }


    lineV(index,x,y,z, vertices) {

        // u

        if ( index > this.parameters.uv.v )
            return false

        let xx = 0, yy = 0, zz = 0, dot = null

        for( let i = 0 ; i <= this.parameters.uv.v ; i++ ) {

            let ii = i * this.parameters.uv.u + index + i

            dot = this.getDot(ii)

            if (typeof(vertices) !== 'undefined') {

                // use vertives as saved position for dragging

                xx = vertices[i].x + x
                yy = vertices[i].y + y
                zz = vertices[i].z + z

            } else {

                xx = dot.x + x
                yy = dot.y + y
                zz = dot.z + z

            }

            this.dot( ii , xx, yy, zz )

            //console.log( '> ' + index + ' ' + ii )

        }

        return this

    }



    dotPush(index,x,y,z , unlock ) {

        // @todo deprecated

        if (index > this.geometry.vertices.length-1 && typeof(unlock) == 'undefined')
            return false

        x = x + this.geometry.vertices[index].x
        y = y + this.geometry.vertices[index].y
        z = z + this.geometry.vertices[index].z

        // dot

        this.geometry.vertices[index].set(x,y,z)    // @todo deprecated

        this.geometry.verticesNeedUpdate = true

        // grid

        this.geometrylines.attributes.position.setXYZ(index,x,y,z)

        this.geometrylines.attributes.position.needsUpdate = true

        return this

    }



    uuid() {

        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )

    }

}